import { Component, OnInit } from '@angular/core';
import { PacienteService } from 'src/app/services/paciente.service';

@Component({
  selector: 'app-menu-historia-clinica',
  templateUrl: './menu-historia-clinica.component.html',
  styles: []
})
export class MenuHistoriaClinicaComponent implements OnInit {

  constructor(
    public _pacienteSrv: PacienteService,
  ) { }

  ngOnInit() {
  }

}
